module.exports = __webpack_public_path__ + "img/grasse_8.0a906a0f.png";